/**
 * TeamsUserInfo.js
 * Created by calhosh on 1/28/2021.
 */

import React from 'react';
import PropTypes from 'prop-types';
import TeamsUserInfo from '@ey/canvascoreservices-teams';
import {useEngagementUserIsEngagementAccessible} from '../../../util/Ares/customHooks';

function TeamsInfo(props) {
	const {personData, peopleData, canvasTheme, personCardInteraction} = props;
	const isEngagementAccessible = useEngagementUserIsEngagementAccessible();

	const modifiedPersonData = !isEngagementAccessible && personData ? {...personData, customTemplate: 'no-data'} : personData;

	return <TeamsUserInfo personData={modifiedPersonData} peopleData={peopleData} personCardInteraction={personCardInteraction} canvasTheme={canvasTheme} />;
}

TeamsInfo.propTypes = {
	/** Sets the user interaction.
	 * Options are: none, click, hover.
	 * Default is hover. */
	personCardInteraction: PropTypes.string,
	personData: PropTypes.shape({
		/** Sets the user email address for graph to use for lookup. */
		person: PropTypes.shape({
			firstName: PropTypes.string,
			lastName: PropTypes.string,
			emailAddress: PropTypes.string,
			role: PropTypes.string
		}),
		/** Sets the view for the user. Defaults to oneline. Options are {
			 Render only the avatar
			avatar = 2,
			Render the avatar and one line of text
			oneline = 3,
			Render the avatar and two lines of text
			twolines = 4,
			Render the avatar and three lines of text
			threelines = 5.
	 	*/
		viewType: PropTypes.string
	}),
	peopleData: PropTypes.shape({
		/** Same as person above but for a group of people. */
		people: PropTypes.arrayOf(
			PropTypes.shape({
				firstName: PropTypes.string,
				lastName: PropTypes.string,
				emailAddress: PropTypes.string.isRequired,
				role: PropTypes.string
			})
		),
		/** The max amount of people to pre display. Defaults to 4.*/
		showMax: PropTypes.number
	})
};

export default TeamsInfo;
